import React from 'react';
import CriteriaRowWrapper from '../CriteriaRowWrapper';
import ToggleList from './ToggleList';
import { Equals, NotEquals, EqualsAll } from 'Resources/ComparisonTypes';
import StackedDateInput from 'Components/Inputs/StackedDateInput/StackedDateInput';
import { useTranslation } from 'Components/Helpers/translate';
import { isActive, type AddedToCampaignValue } from 'App/babel/filters/AddedToCampaign';

type Filter = { value: AddedToCampaignValue; inactive?: boolean };

type Props = {
	filter: Filter;
	config: { listConfig: object };
	selectData: object;
	LIST_AJAX_LIMIT: number;
	onChange: (value: AddedToCampaignValue, filter: Filter) => void;
};

const AddedToCampaignInput = ({ filter, config, selectData, LIST_AJAX_LIMIT, onChange }: Props) => {
	const { t } = useTranslation();

	const update = (value: AddedToCampaignValue) => onChange(value, { ...filter, value, inactive: !isActive(value) });

	const listProps = {
		placeholder: t('select_campaign'),
		config: config.listConfig,
		defaultValue: filter.value.Campaign.value,
		onChange: (ids: number[]) =>
			update({ ...filter.value, Campaign: { ...filter.value.Campaign, value: ids?.length ? ids : null } }),
		selectData,
		LIST_AJAX_LIMIT
	};

	const toggleProps = {
		options: [
			{ value: Equals, text: t('default.any') },
			{ value: EqualsAll, text: t('default.all') },
			{ value: NotEquals, text: t('comparison.NotEquals') }
		],
		onClick: (comparisonType: string) =>
			update({ ...filter.value, Campaign: { ...filter.value.Campaign, comparisonType } }),
		value: filter.value.Campaign.comparisonType
	};

	return (
		<CriteriaRowWrapper className="" max800w rowFlex={false}>
			<div className="criteria-row">
				<ToggleList
					className="col-sm-8"
					list={listProps}
					toggle={toggleProps}
					isListActive={() => !!filter.value.Campaign.value?.length}
				/>
				<div className="col-sm-4">
					<StackedDateInput
						config={{}}
						filter={filter.value.Date}
						onChange={(date: AddedToCampaignValue['Date']) => update({ ...filter.value, Date: date })}
						required={false}
					/>
				</div>
			</div>
		</CriteriaRowWrapper>
	);
};

export default AddedToCampaignInput;
